import { useMutation } from '@tanstack/react-query';
import moment from 'moment';
import { downloadSupportChatCSVAPI } from '../../../api/supportChat';
import { notifyError } from '../../../utils/notify';
import transformFiltersForApi from '../utils/transformFiltersForApi';

const downloadCSV = async conversationFilters => {
  const apiFilters = transformFiltersForApi(conversationFilters);
  const res = await downloadSupportChatCSVAPI(apiFilters);
  return res.data;
};

const triggerDownload = csvData => {
  const encodedUri = `data:application/csv;charset=utf-8,${encodeURIComponent(
    csvData
  )}`;
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute(
    'download',
    `support-chat-conversations-${moment().format('YYYY-MM-DD')}.csv`
  );
  link.innerHTML = 'Support Chat Conversations';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const useDownloadSupportChatCSVMutation = () =>
  useMutation(data => downloadCSV(data), {
    onSuccess: csvData => {
      triggerDownload(csvData);
    },
    onError: e => {
      notifyError(e, false, 'Error downloading CSV data');
    },
  });

export default useDownloadSupportChatCSVMutation;
